import React, { useState, useEffect } from "react";
import { Form, Formik, ErrorMessage } from "formik";
import TextInput from "../../components/TextInput";
import SelectInput from "../../components/selectinput";
import TextArea from "../../components/TextArea";
import RadioInput from "../../components/RadioInput";
import NumberInput from "../../components/NumberInput";
import { isValidEmail } from "../../utils/isValidEmail";
import { Fn } from "../../utils/rutValidation";
import {
  createSolicitud,
  getSolicitudInfoById,
  fetchSectores,
  getSolicitudById,
  createRespuestasSolicitud,
  fetchRespuestas,
  updateSolicitud,
  updateRespuestas,
  fetchDocument,
  deleteDocument,
  fetchTiposOrganizaciones,
  fetchBancos,
  fetchLineasFinanciamiento,
  rutPuedePostular,
} from "../../services/solicitud";
import Navbar from "../../components/Navbar";
import { ToastContainer, toast } from "react-toastify";
import FileButtonUploader from "../../components/fileuploader";
import DocumentItem from "../../components/documentitem";
import Swal from "sweetalert2";
import {
  Asterisk,
  Bullet,
  ButtonAtras,
  ButtonEnviar,
  ButtonNext,
  CheckIcon,
  CloseIcon,
  Div,
  DivButtons,
  DivContenedorMax,
  DivFlex,
  DivFlex2,
  DivFlexP4,
  DivFlexP5,
  DivForm,
  ErrorMessageP4,
  ErrorMessageP5,
  FechaTerminoIcon,
  FieldP5,
  FormContainer,
  FormContainerP4,
  FormContainerP5,
  FormGroup,
  FormGroupP4,
  FormLabel,
  FormLabelP4,
  FormLabelP5,
  Icon,
  ImgReferencia,
  Label,
  PI,
  ProgressBar,
  SaveIcon,
  Step,
  StepProgress,
  TableP4,
  TableP5,
} from "./FormularioStyle";
import CustomLoading from "../../components/Loading";

// Función para convertir un archivo a base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      const arrayBuffer = reader.result;
      const bytes = new Uint8Array(arrayBuffer);
      let binary = "";
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      const base64String = btoa(binary);
      resolve(base64String);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

const totalSteps = 8;

let anio = new Date().getFullYear();

// Componente para mostrar y manejar documentos

// Componente principal del formulario
const MultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(-1);
  const [errores, setErrores] = useState([]);
  const [animating, setAnimating] = useState(false);
  const [solicitud, setSolicitud] = useState([]);
  const [fecha, setFecha] = useState(0);
  const [solicitudDraft, setSolicitudDraft] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState({});
  const [tokenData, setTokenData] = useState({});
  const [respuestas, setRespuestas] = useState([]);
  const [presupuestos, setPresupuestos] = useState([]);
  const [presupuestoInfra, setPresupuestosInfra] = useState([]);
  const [presupuestoHhrr, setPresupuestosHhrr] = useState([]);

  const [draftLoading, setDraftLoading] = useState(false);
  const [pendingDisabled, setPendingDisabled] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [lineasFinanciamiento, setLineasFinanciamiento] = useState([]);
  const [maximoFinanciamiento, setMaximoFinanciamiento] = useState(999999999);
  const [sectores, setSectores] = useState([]);
  const [showImage, setShowImage] = useState(false);
  const [presupuestoTotal, setPresupuestoTotal] = useState(0);
  const [presupuestoValido, setPresupuestoValido] = useState(false);
  const [mensajePresupuesto, setMensajePresupuesto] = useState("");
  const [recursosHumanosTotal, setRecursosHumanosTotal] = useState(0);
  const [documentosSolicitud, setDocumentosSolicitud] = useState([]);

  const [goRows, setGoRows] = useState(3);
  const [inRows, setInRows] = useState(1);
  const [rhRows, setRhRows] = useState(1);

  const getTiposDeCuenta = () => {
    return [
      { id: "vista", nombre: "Cuenta vista" },
      { id: "corriente", nombre: "Cuenta corriente" },
      { id: "ahorro", nombre: "Cuenta de ahorro" },
    ];
  };

  const getCategoriasDocumentos = () => {
    return [
      {
        nombre: "Certificado de vigencia de la organización",
        id: "Certificado de vigen",
      },
      {
        nombre:
          "Cédula de identidad del representante legal de la organización",
        id: "Certificado de cedul",
      },
      {
        nombre: "Cédula de identidad de un integrante de la directiva",
        id: "Cedula directiva",
      },
      {
        nombre: "Cédula de identidad de otro integrante de la directiva",
        id: "Cedula directiva 2",
      },
      { nombre: "Cuenta bancaria", id: "CertificadoBancario" },
      {
        nombre: "Carta de compriso del trabajador/a",
        id: "CertificadoCartaComp",
      },
      { nombre: "Cotizaciones", id: "CertificadoCotizacio" },
    ];
  };

  const handleDelete = async (doc) => {
    if (!doc.id_documento) {
      toast.error("Documento invalido.");
      return;
    }
    try {
      const promesa = deleteDocument(doc.id_documento);
      await toast.promise(promesa, {
        pending: "Eliminando documento...",
        error: "Ocurrió un error al intentar eliminar",
        success: "Eliminado!",
      });
      const documentosNuevos = [];
      for (const i of documentosSolicitud) {
        if (i.id_documento !== doc.id_documento) {
          documentosNuevos.push(i);
        }
      }
      setDocumentosSolicitud(documentosNuevos);
    } catch (error) {}
  };

  const handleUploadSucces = async (doc) => {
    const documentosNuevos = documentosSolicitud;
    documentosNuevos.push(doc);
    validate({}, 8);
    setDocumentosSolicitud(documentosNuevos);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const lineas = await fetchLineasFinanciamiento();
        setLineasFinanciamiento(lineas);
      } catch (error) {
        console.error("Error fetching lineas de financiamiento:", error);
      }
    };

    fetchData();
  }, []);

  const handleLineaFinanciamientoChange = (value) => {
    const lineaSeleccionada = lineasFinanciamiento.find(
      (linea) => linea.nombre === value
    );
    if (lineaSeleccionada) {
      setMaximoFinanciamiento(lineaSeleccionada.max_capital);
    }
  };

  const saveSolicitud = async (values, isDraft, isNewSolicitud) => {
    const queryParams = new URLSearchParams(window.location.search);
    const id_solicitud_ = isNewSolicitud
      ? null
      : queryParams.get("id_postulacion");
    const idProceso = queryParams.get("id_proceso");
    const estado = isDraft ? "Borrador" : "Pendiente";

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return year + "-" + month + "-" + day;
    };

    const createSolicitudForm = {
      nombre_proyecto: values.NombreProyecto,
      nombre_organizacion: values.NombreOrg,
      numero_beneficiarios: values.NumBeneficiarios,
      linea_financiamiento: values.radio,
      aporte_solicitado: values.AporteSolicitado,
      rut_organizacion: values.RUTOrg,
      direccion_org: values.DirOrg,
      nombre_representante_legal: values.NombreRepLegal,
      rut_representante_legal: values.RUTRepLegal,
      direccion_rep_legal: values.DirRepLegal,
      telefono_rep_legal: values.TelRepLegal
        ? values.TelRepLegal.toString()
        : "",
      correo_rep_legal: values.CorreoRepLegal,
      nombre_responsable_proy: values.NombreRespProyecto,
      rut_responsable_proy: values.RUTRespProyecto,
      direccion_responsable_proy: values.DirRespProyecto,
      telefono_responsable_proy: values.TelRespProyecto
        ? values.TelRespProyecto.toString()
        : "",
      correo_responsable_proy: values.CorreoRespProyecto,
      id_tipo_organizacion: values.tipoOrganizacion,
      sector_id: values.sector,
      cuenta_id_banco: values.idBanco,
      cuenta_tipo: values.tipoCuenta,
      cuenta_numero: values.numeroCuenta,
      cuenta_titular: values.titularCuenta,
      cuenta_correo: values.correoCuenta,
      estado: estado,
      id_proceso: idProceso,
      rut_evaluador: null,
      rut_solicitante: user.rut_usuario,
      email_solicitante: user.correo_usuario,
      Fecha_Postulacion: formatDate(new Date()),
      gasto_operacional_item_0: values.GoperacionalesItem_0,
      gasto_operacional_utilizacion_0: values.GoperacionalesUtilizacion_0,
      gasto_operacional_monto_0: parseInt(
        values["GoperacionalesMontoSolicitado_0"]
      ),
      gasto_operacional_item_1: values.GoperacionalesItem_1,
      gasto_operacional_utilizacion_1: values.GoperacionalesUtilizacion_1,
      gasto_operacional_monto_1: parseInt(
        values["GoperacionalesMontoSolicitado_1"]
      ),
      gasto_operacional_item_2: values.GoperacionalesItem_2,
      gasto_operacional_utilizacion_2: values.GoperacionalesUtilizacion_2,
      gasto_operacional_monto_2: parseInt(
        values["GoperacionalesMontoSolicitado_2"]
      ),
      gasto_operacional_item_3: values.GoperacionalesItem_3,
      gasto_operacional_utilizacion_3: values.GoperacionalesUtilizacion_3,
      gasto_operacional_monto_3: parseInt(
        values["GoperacionalesMontoSolicitado_3"]
      ),
      gasto_operacional_item_4: values.GoperacionalesItem_4,
      gasto_operacional_utilizacion_4: values.GoperacionalesUtilizacion_4,
      gasto_operacional_monto_4: parseInt(
        values["GoperacionalesMontoSolicitado_4"]
      ),

      gasto_operacional_item_5: values.GoperacionalesItem_5,
      gasto_operacional_utilizacion_5: values.GoperacionalesUtilizacion_5,
      gasto_operacional_monto_5: parseInt(
        values["GoperacionalesMontoSolicitado_5"]
      ),

      gasto_operacional_item_6: values.GoperacionalesItem_6,
      gasto_operacional_utilizacion_6: values.GoperacionalesUtilizacion_6,
      gasto_operacional_monto_6: parseInt(
        values["GoperacionalesMontoSolicitado_6"]
      ),

      gasto_operacional_item_7: values.GoperacionalesItem_7,
      gasto_operacional_utilizacion_7: values.GoperacionalesUtilizacion_7,
      gasto_operacional_monto_7: parseInt(
        values["GoperacionalesMontoSolicitado_7"]
      ),

      gasto_operacional_item_8: values.GoperacionalesItem_8,
      gasto_operacional_utilizacion_8: values.GoperacionalesUtilizacion_8,
      gasto_operacional_monto_8: parseInt(
        values["GoperacionalesMontoSolicitado_8"]
      ),

      gasto_operacional_item_9: values.GoperacionalesItem_9,
      gasto_operacional_utilizacion_9: values.GoperacionalesUtilizacion_9,
      gasto_operacional_monto_9: parseInt(
        values["GoperacionalesMontoSolicitado_9"]
      ),

      infra_item_0: values.InfraestructuraItem_0,
      infra_utilizacion_0: values.InfraestructuraUtilizacion_0,
      infra_monto_0: parseInt(values["InfraestructuraMontoSolicitado_0"]),
      infra_item_1: values.InfraestructuraItem_1,
      infra_utilizacion_1: values.InfraestructuraUtilizacion_1,
      infra_monto_1: parseInt(values["InfraestructuraMontoSolicitado_1"]),

      infra_item_2: values.InfraestructuraItem_2,
      infra_utilizacion_2: values.InfraestructuraUtilizacion_2,
      infra_monto_2: parseInt(values["InfraestructuraMontoSolicitado_2"]),

      infra_item_3: values.InfraestructuraItem_3,
      infra_utilizacion_3: values.InfraestructuraUtilizacion_3,
      infra_monto_3: parseInt(values["InfraestructuraMontoSolicitado_3"]),

      infra_item_4: values.InfraestructuraItem_4,
      infra_utilizacion_4: values.InfraestructuraUtilizacion_4,
      infra_monto_4: parseInt(values["InfraestructuraMontoSolicitado_4"]),

      rrhh_item_0: values.RecursosHumanosItem_0,
      rrhh_utilizacion_0: values.RecursosHumanosUtilizacion_0,
      rrhh_monto_0: parseInt(values["RecursosHumanosMontoSolicitado_0"]),
      rrhh_item_1: values.RecursosHumanosItem_1,
      rrhh_utilizacion_1: values.RecursosHumanosUtilizacion_1,
      rrhh_monto_1: parseInt(values["RecursosHumanosMontoSolicitado_1"]),

      rrhh_item_2: values.RecursosHumanosItem_2,
      rrhh_utilizacion_2: values.RecursosHumanosUtilizacion_2,
      rrhh_monto_2: parseInt(values["RecursosHumanosMontoSolicitado_2"]),

      rrhh_item_3: values.RecursosHumanosItem_3,
      rrhh_utilizacion_3: values.RecursosHumanosUtilizacion_3,
      rrhh_monto_3: parseInt(values["RecursosHumanosMontoSolicitado_3"]),

      rrhh_item_4: values.RecursosHumanosItem_4,
      rrhh_utilizacion_4: values.RecursosHumanosUtilizacion_4,
      rrhh_monto_4: parseInt(values["RecursosHumanosMontoSolicitado_4"]),

      obs_presupuesto: values.ObsPresupuesto,
      plan_difusion: values.PlanDifusion,
      is_draft: isDraft,
    };

    const respuestasSolicitud = {
      id_solicitud: id_solicitud_,
      identificacion_problema: values.IdProblema,
      beneficiarios: values.Beneficiarios,
      descripcion_proyecto: values.DesProyecto,
      objetivo_general: values.ObjetivoGeneral,
      objetivo_especifico_1: values.ObjetivoEspec1,
      objetivo_especifico_2: values.ObjetivoEspec2,
      objetivo_especifico_3: values.ObjetivoEspec3,
      nombre_actividad_0: values.ActividadesNombre_0,
      descripcion_actividad_0: values.ActividadesDescripcion_0,
      nombre_actividad_1: values.ActividadesNombre_1,
      descripcion_actividad_1: values.ActividadesDescripcion_1,
      nombre_actividad_2: values.ActividadesNombre_2,
      descripcion_actividad_2: values.ActividadesDescripcion_2,
      nombre_actividad_3: values.ActividadesNombre_3,
      descripcion_actividad_3: values.ActividadesDescripcion_3,
      nombre_actividad_4: values.ActividadesNombre_4,
      descripcion_actividad_4: values.ActividadesDescripcion_4,
    };

    try {
      let response;
      if (isNewSolicitud) {
        response = await createSolicitud(createSolicitudForm, isDraft);
        console.log("response new solicitud:", response);
        respuestasSolicitud.id_solicitud = response.id_solicitud;
      } else {
        response = await updateSolicitud(id_solicitud_, createSolicitudForm);
      }

      if (response) {
        if (isNewSolicitud) {
          await createRespuestasSolicitud(respuestasSolicitud);
        } else {
          await updateRespuestas(id_solicitud_, respuestasSolicitud);
        }

        console.log("Resultado de guardar principal:", response);
        return {
          ok: true,
          response,
        };
      }
    } catch (error) {
      return {
        ok: false,
        error,
      };
    }
  };

  const handleSubmit = async (values) => {
    const confirmar = await Swal.fire({
      title: "¿Enviar?",
      text: "¿Está seguro/a de enviar el formulario? Asegurese de que todos los campos estan correctos.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, enviar",
      cancelButtonText: "Cancelar",
    });
    if (confirmar.isConfirmed) {
      setIsLoadingSubmit(true);
      Swal.fire({
        title: "Cargando...",
        text: "Por favor, espera un momento mientras validamos y recibimos tu solicitud...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
      const success = await saveSolicitud(values, false, !isDraft);
      setIsLoadingSubmit(false);
      if (success.ok) {
        Swal.fire({
          title: "¡Listo!",
          text: "Solicitud enviada con exito",
          icon: "success",
          confirmButtonText: "Aceptar",
        });
        window.location.href = "/FeedPostulante";
      } else {
        let msg = "";
        if (success.error.response.data.detail) {
          msg = success.error.response.data.detail;
        }
        Swal.fire({
          icon: "error",
          title: "Ocurrió un error al enviar la solicitud.",
          text: msg,
        });
      }
    }
  };

  const autoSave = async (values) => {
    console.log("Auto guardando cambios...");
    const saving = async () => {
      const result = await handleSaveDraft(values);
      if (!result) {
        throw "error";
      }
    };
    toast.promise(saving, {
      pending: "Guardando borrador",
      success: "Borrador guardado",
      error: "Ocurrió un error al guardar",
    });
  };

  const handleSaveDraft = async (values) => {
    setDraftLoading(true);
    const req = await saveSolicitud(values, true, !isDraft);

    if (req.ok) {
      const success = req.response;
      if (!isDraft) {
        // Si es una nueva solicitud, actualizamos el estado y la URL
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("id_postulacion", success.id_solicitud); // success.id_solicitud es el ID generado
        window.history.replaceState(
          {},
          "",
          `${window.location.pathname}?${queryParams.toString()}`
        );

        // Actualizamos el estado para que el formulario se comporte como un borrador existente
        setIsDraft(true);
        setSolicitudDraft(success); // success contiene los datos de la solicitud guardada
      }

      //alert("Borrador guardado correctamente");
    } else {
      return false;
      //alert("Error al guardar el borrador, verifica tu conexión a internet o intentalo de nuevo más tarde.");
    }

    setDraftLoading(false);
    return true;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = sessionStorage.getItem("userData");
        const token = sessionStorage.getItem("token");
        const solicitudesEnabled = sessionStorage.getItem("solicitudesEnabled");
        const queryParams = new URLSearchParams(window.location.search);
        const idProceso = queryParams.get("id_proceso");
        const idPostulacion = queryParams.get("id_postulacion");

        setTokenData(token);
        const user = JSON.parse(userData);
        setUser(user);

        const lineas = await fetchLineasFinanciamiento();
        setLineasFinanciamiento(lineas);
        const sectores = await fetchSectores(token);
        setSectores(sectores);

        if (
          user.rol === "Postulante" &&
          !solicitudesEnabled.includes(idPostulacion) &&
          !idProceso
        ) {
          window.location.href = "/feedPostulante";
          return;
        }

        if (idProceso) {
          const solicitud = await getSolicitudById(idProceso, token);
          if (solicitud) {
            setSolicitud(solicitud);
            const fechaObjetivo = new Date(solicitud.fecha_fin);
            const fechaActual = new Date();
            setFecha(
              Math.ceil((fechaObjetivo - fechaActual) / (1000 * 60 * 60 * 24))
            );
          }
          setIsLoading(false);
          return;
        }

        if (idPostulacion) {
          setIsDraft(true);
          const solicitudDraft = await getSolicitudInfoById(
            idPostulacion,
            token
          );
          setSolicitudDraft(solicitudDraft);
          setPendingDisabled(solicitudDraft.estado !== "Borrador");
          console.log("solicitudDraft", solicitudDraft);
          const proceso = await getSolicitudById(solicitudDraft.id_proceso);
          if (proceso.fecha_fin) {
            const fechaObjetivo = new Date(proceso.fecha_fin);
            const fechaActual = new Date();
            setFecha(
              Math.ceil((fechaObjetivo - fechaActual) / (1000 * 60 * 60 * 24))
            );
          }
          const lineaSeleccionada = lineas.find(
            (linea) => linea.nombre === solicitudDraft.linea_financiamiento
          );

          if (lineaSeleccionada) {
            setMaximoFinanciamiento(lineaSeleccionada.max_capital);
          }

          const respuestasX = await fetchRespuestas(idPostulacion);
          if (respuestasX) {
            const respuestas = respuestasX[0];
            setRespuestas(respuestas);
          }

          const documentos = await fetchDocument(idPostulacion);
          if (documentos) {
            setDocumentosSolicitud(documentos);
          }

          //Validamos todos los campos que se traen del draft

          //validar step 1
          validate(
            {
              NombreProyecto: solicitudDraft.nombre_proyecto,
              radio: solicitudDraft.linea_financiamiento,
              NumBeneficiarios: solicitudDraft.numero_beneficiarios,
              AporteSolicitado: solicitudDraft.aporte_solicitado,
            },
            0
          );

          //validar step 2
          // Validar el paso 1 con los datos del draft
          validate(
            {
              NombreOrg: solicitudDraft.nombre_organizacion,
              RUTOrg: solicitudDraft.rut_organizacion,
              DirOrg: solicitudDraft.direccion_org,
              tipoOrganizacion: solicitudDraft.id_tipo_organizacion,
              sector: solicitudDraft.sector_id,
            },
            1
          );

          validate(
            {
              NombreRepLegal: solicitudDraft.nombre_representante_legal,
              RUTRepLegal: solicitudDraft.rut_representante_legal,
              DirRepLegal: solicitudDraft.direccion_rep_legal,
              TelRepLegal: solicitudDraft.telefono_rep_legal,
              CorreoRepLegal: solicitudDraft.correo_rep_legal,
            },
            2
          );
          // Validar el paso 2 con los datos del draft
          console.log("respuestas?", respuestasX);
          validate(
            {
              NombreRespProyecto: solicitudDraft.nombre_responsable_proy,
              RUTRespProyecto: solicitudDraft.rut_responsable_proy,
              DirRespProyecto: solicitudDraft.direccion_responsable_proy,
              TelRespProyecto: solicitudDraft.telefono_responsable_proy,
              CorreoRespProyecto: solicitudDraft.correo_responsable_proy,
            },
            3
          );
          let resp = {};
          if (respuestasX.length > 0) {
            resp = respuestasX[0];
          }

          validate(
            {
              idBanco: solicitudDraft.cuenta_id_banco,
              tipoCuenta: solicitudDraft.cuenta_tipo,
              numeroCuenta: solicitudDraft.cuenta_numero,
              titularCuenta: solicitudDraft.cuenta_titular,
              correoCuenta: solicitudDraft.cuenta_correo,
            },
            4
          );
          validate(
            {
              IdProblema: resp.identificacion_problema,
              Beneficiarios: resp.beneficiarios,
              DesProyecto: resp.descripcion_proyecto,
              ObjetivoGeneral: resp.objetivo_general,
              ObjetivoEspec1: resp.objetivo_especifico_1,
              ObjetivoEspec2: resp.objetivo_especifico_2,
              ObjetivoEspec3: resp.objetivo_especifico_3,
            },
            5
          );

          // Validar el paso 3 con los datos del draft
          validate(
            {
              ActividadesNombre_0: resp.nombre_actividad_0,
              ActividadesDescripcion_0: resp.descripcion_actividad_0,
              ActividadesNombre_1: resp.nombre_actividad_1,
              ActividadesDescripcion_1: resp.descripcion_actividad_1,
              ActividadesNombre_2: resp.nombre_actividad_2,
              ActividadesDescripcion_2: resp.descripcion_actividad_2,
              ActividadesNombre_3: resp.nombre_actividad_3,
              ActividadesDescripcion_3: resp.descripcion_actividad_3,
              ActividadesNombre_4: resp.nombre_actividad_4,
              ActividadesDescripcion_4: resp.descripcion_actividad_4,
              PlanDifusion: solicitudDraft.plan_difusion,
            },
            6
          );

          // Validar el paso 4 con los datos del draft
          validate(
            {
              AporteSolicitado: solicitudDraft.aporte_solicitado,

              GoperacionalesItem_0: solicitudDraft.gasto_operacional_item_0,
              GoperacionalesUtilizacion_0:
                solicitudDraft.gasto_operacional_utilizacion_0,
              GoperacionalesMontoSolicitado_0:
                solicitudDraft.gasto_operacional_monto_0,
              GoperacionalesItem_1: solicitudDraft.gasto_operacional_item_1,
              GoperacionalesUtilizacion_1:
                solicitudDraft.gasto_operacional_utilizacion_1,
              GoperacionalesMontoSolicitado_1:
                solicitudDraft.gasto_operacional_monto_1,
              GoperacionalesItem_2: solicitudDraft.gasto_operacional_item_2,
              GoperacionalesUtilizacion_2:
                solicitudDraft.gasto_operacional_utilizacion_2,
              GoperacionalesMontoSolicitado_2:
                solicitudDraft.gasto_operacional_monto_2,
              GoperacionalesItem_3: solicitudDraft.gasto_operacional_item_3,
              GoperacionalesUtilizacion_3:
                solicitudDraft.gasto_operacional_utilizacion_3,
              GoperacionalesMontoSolicitado_3:
                solicitudDraft.gasto_operacional_monto_3,
              GoperacionalesItem_4: solicitudDraft.gasto_operacional_item_4,
              GoperacionalesUtilizacion_4:
                solicitudDraft.gasto_operacional_utilizacion_4,
              GoperacionalesMontoSolicitado_4:
                solicitudDraft.gasto_operacional_monto_4,
              GoperacionalesItem_5: solicitudDraft.gasto_operacional_item_5,
              GoperacionalesUtilizacion_5:
                solicitudDraft.gasto_operacional_utilizacion_5,
              GoperacionalesMontoSolicitado_5:
                solicitudDraft.gasto_operacional_monto_5,
              GoperacionalesItem_6: solicitudDraft.gasto_operacional_item_6,
              GoperacionalesUtilizacion_6:
                solicitudDraft.gasto_operacional_utilizacion_6,
              GoperacionalesMontoSolicitado_6:
                solicitudDraft.gasto_operacional_monto_6,
              GoperacionalesItem_7: solicitudDraft.gasto_operacional_item_7,
              GoperacionalesUtilizacion_7:
                solicitudDraft.gasto_operacional_utilizacion_7,
              GoperacionalesMontoSolicitado_7:
                solicitudDraft.gasto_operacional_monto_7,
              GoperacionalesItem_8: solicitudDraft.gasto_operacional_item_8,
              GoperacionalesUtilizacion_8:
                solicitudDraft.gasto_operacional_utilizacion_8,
              GoperacionalesMontoSolicitado_8:
                solicitudDraft.gasto_operacional_monto_8,
              GoperacionalesItem_9: solicitudDraft.gasto_operacional_item_9,
              GoperacionalesUtilizacion_9:
                solicitudDraft.gasto_operacional_utilizacion_9,
              GoperacionalesMontoSolicitado_9:
                solicitudDraft.gasto_operacional_monto_9,

              InfraestructuraItem_0: solicitudDraft.infra_item_0,
              InfraestructuraUtilizacion_0: solicitudDraft.infra_utilizacion_0,
              InfraestructuraMontoSolicitado_0: solicitudDraft.infra_monto_0,
              InfraestructuraItem_1: solicitudDraft.infra_item_1,
              InfraestructuraUtilizacion_1: solicitudDraft.infra_utilizacion_1,
              InfraestructuraMontoSolicitado_1: solicitudDraft.infra_monto_1,
              InfraestructuraItem_2: solicitudDraft.infra_item_2,
              InfraestructuraUtilizacion_2: solicitudDraft.infra_utilizacion_2,
              InfraestructuraMontoSolicitado_2: solicitudDraft.infra_monto_2,
              InfraestructuraItem_3: solicitudDraft.infra_item_3,
              InfraestructuraUtilizacion_3: solicitudDraft.infra_utilizacion_3,
              InfraestructuraMontoSolicitado_3: solicitudDraft.infra_monto_3,
              InfraestructuraItem_4: solicitudDraft.infra_item_4,
              InfraestructuraUtilizacion_4: solicitudDraft.infra_utilizacion_4,
              InfraestructuraMontoSolicitado_4: solicitudDraft.infra_monto_4,

              RecursosHumanosItem_0: solicitudDraft.rrhh_item_0,
              RecursosHumanosUtilizacion_0: solicitudDraft.rrhh_utilizacion_0,
              RecursosHumanosMontoSolicitado_0: solicitudDraft.rrhh_monto_0,
              RecursosHumanosItem_1: solicitudDraft.rrhh_item_1,
              RecursosHumanosUtilizacion_1: solicitudDraft.rrhh_utilizacion_1,
              RecursosHumanosMontoSolicitado_1: solicitudDraft.rrhh_monto_1,
              RecursosHumanosItem_2: solicitudDraft.rrhh_item_2,
              RecursosHumanosUtilizacion_2: solicitudDraft.rrhh_utilizacion_2,
              RecursosHumanosMontoSolicitado_2: solicitudDraft.rrhh_monto_2,
              RecursosHumanosItem_3: solicitudDraft.rrhh_item_3,
              RecursosHumanosUtilizacion_3: solicitudDraft.rrhh_utilizacion_3,
              RecursosHumanosMontoSolicitado_3: solicitudDraft.rrhh_monto_3,
              RecursosHumanosItem_4: solicitudDraft.rrhh_item_4,
              RecursosHumanosUtilizacion_4: solicitudDraft.rrhh_utilizacion_4,
              RecursosHumanosMontoSolicitado_4: solicitudDraft.rrhh_monto_4,
            },
            7
          );

          // Validar el paso 5 con los datos del draft
          validate({}, 8);

          for (let i = 0; i < 10; i++) {
            if (
              solicitudDraft["gasto_operacional_item_" + i] ||
              solicitudDraft["gasto_operacional_utilizacion_" + i] ||
              solicitudDraft["gasto_operacional_monto_" + i]
            ) {
              setGoRows(i + 1);
            }

            if (i < 5) {
              if (
                solicitudDraft["infra_item_" + i] ||
                solicitudDraft["infra_utilizacion_" + i] ||
                solicitudDraft["infra_monto_" + i]
              ) {
                setInRows(i + 1);
              }
              if (
                solicitudDraft["rrhh_item_" + i] ||
                solicitudDraft["rrhh_utilizacion_" + i] ||
                solicitudDraft["rrhh_monto_" + i]
              ) {
                setRhRows(i + 1);
              }
            }
          }

          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error al obtener los datos", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    validate({}, 8);
  }, [documentosSolicitud]);

  const [stepValid, setStepValid] = useState(Array(totalSteps).fill(false));
  const allStepsValid = stepValid.every((step) => step === true);

  const nextStep = (values) => {
    autoSave(values);
    setAnimating(true);
    setTimeout(() => {
      setCurrentStep(currentStep + 1);
      setTimeout(() => {
        setAnimating(false);
      }, 500);
    }, 0);
  };

  const prevStep = (values) => {
    autoSave(values);
    setAnimating(true);
    setTimeout(() => {
      setCurrentStep(currentStep - 1);
      setTimeout(() => {
        setAnimating(false);
      }, 500);
    }, 0);
  };

  const validateRut = (rut) => {
    if (!rut) {
      return "RUT requerido";
    }
    if (!Fn.validaRut(rut)) {
      console.log(Fn.formatRut(rut));
      return "RUT inválido, debe ir sin puntos y con guion";
    }

    return null;
  };

  const validate = async (values, currentStep) => {
    const errors = {};

    // Validate Step 1
    if (currentStep === 0) {
      if (!values.NombreProyecto) {
        errors.NombreProyecto = "Nombre proyecto Requerido";
      } else if (values.NombreProyecto.length < 5) {
        errors.NombreProyecto = "Nombre proyecto Es muy corto";
      }
      if (!values.radio) {
        errors.radio = "Linea de financiamiento Requerido";
      }

      if (
        values.NumBeneficiarios <= 0 ||
        values.NumBeneficiarios == null ||
        values.NumBeneficiarios === ""
      ) {
        errors.NumBeneficiarios = "Num. Beneficiarios requerido";
      }
      if (
        values.AporteSolicitado <= 0 ||
        values.AporteSolicitado == null ||
        values.AporteSolicitado === ""
      ) {
        errors.AporteSolicitado = "Aporte solicitado requerido";
      }
      if (values.AporteSolicitado > maximoFinanciamiento) {
        errors.AporteSolicitado =
          "El máximo a solicitar es de $" + maximoFinanciamiento;
      }
    }
    // Fin validate step 1

    // Validate Step 2
    else if (currentStep === 1) {
      if (!values.NombreOrg) {
        errors.NombreOrg = "Nombre de la organización requerido";
      } else if (values.NombreOrg.length < 3) {
        errors.NombreOrg = "Nombre de la organización muy corto";
      }
      if (!values.RUTOrg) {
        errors.RUTOrg = "RUT de la organización requerido";
      } else {
        const rutError0 = validateRut(values.RUTOrg);
        if (rutError0) {
          errors.RUTOrg = rutError0;
        }

        //validar rut que puede
        const puedeResult = await rutPuedePostular(values.RUTOrg);
        if (!puedeResult.habilitado) {
          errors.RUTOrg =
            "El RUT " +
            values.RUTOrg +
            " no puede postular. Los ganadores deben esperar dos años para volver a postular, y solo se puede postular a un proceso por RUT.";
        }
      }
      if (!values.DirOrg) {
        errors.DirOrg = "Dirección de la organización requerida";
      } else if (values.DirOrg.length < 3) {
        errors.DirOrg = "Dirección de la organización muy corta";
      }

      if (!values.tipoOrganizacion) {
        errors.tipoOrganizacion = "Debe seleccionar un tipo de organización";
      }

      if (!values.sector) {
        errors.sector = "Debe seleccionar un sector";
      }
    }
    // Fin validate step 2

    // Fin validate step 3
    else if (currentStep === 2) {
      if (!values.NombreRepLegal) {
        errors.NombreRepLegal = "Nombre del representante legal requerido";
      } else if (values.NombreRepLegal.length < 3) {
        errors.NombreRepLegal = "Nombre del representante legal muy corto";
      }
      if (!values.DirRepLegal) {
        errors.DirRepLegal = "Dirección del representante legal requerida";
      } else if (values.DirRepLegal.length < 3) {
        errors.DirRepLegal = "Dirección del representante legal muy corta";
      }
      if (!values.TelRepLegal) {
        errors.TelRepLegal = "Teléfono del representante legal requerido";
      }
      if (!values.CorreoRepLegal) {
        errors.CorreoRepLegal = "Correo del representante legal requerido";
      } else if (!isValidEmail(values.CorreoRepLegal)) {
        errors.CorreoRepLegal =
          "Formato de correo del representante legal inválido";
      }
      if (!values.RUTRepLegal) {
        errors.RUTRepLegal = "RUT del responsable del proyecto requerido";
      } else {
        const rutError1 = validateRut(values.RUTRepLegal);
        if (rutError1) {
          errors.RUTRepLegal = rutError1;
        }
      }
    }
    //Fin validate step 3

    //Validate step 4
    else if (currentStep === 3) {
      if (!values.RUTRespProyecto) {
        errors.RUTRespProyecto = "RUT del responsable del proyecto requerido";
      } else {
        const rutError = validateRut(values.RUTRespProyecto);
        if (rutError) {
          errors.RUTRespProyecto = rutError;
        }
      }
      if (!values.NombreRespProyecto) {
        errors.NombreRespProyecto =
          "Nombre del responsable del proyecto requerido";
      } else if (values.NombreRespProyecto.length < 3) {
        errors.NombreRespProyecto =
          "Nombre del responsable del proyecto muy corto";
      }

      if (!values.DirRespProyecto) {
        errors.DirRespProyecto =
          "Dirección del responsable del proyecto requerida";
      } else if (values.DirRespProyecto.length < 3) {
        errors.DirRespProyecto =
          "Dirección del responsable del proyecto muy corta";
      }
      if (!values.TelRespProyecto) {
        errors.TelRespProyecto =
          "Teléfono del responsable del proyecto requerido";
      }
      if (!values.CorreoRespProyecto) {
        errors.CorreoRespProyecto =
          "Correo del responsable del proyecto requerido";
      } else if (!isValidEmail(values.CorreoRespProyecto)) {
        errors.CorreoRespProyecto =
          "Formato de correo del responsable del proyecto inválido";
      }
    }
    // Fin validate step 4

    // Validate Step 5
    else if (currentStep === 4) {
      if (!values.idBanco) {
        errors.idBanco = "Debe seleccionar un banco";
      }

      if (!values.tipoCuenta) {
        errors.tipoCuenta = "Debe seleccionar un tipo de cuenta bancaria";
      }

      if (!values.titularCuenta) {
        errors.titularCuenta = "Debe escribir un titular de la cuenta bancaria";
      }

      if (!values.numeroCuenta) {
        errors.numeroCuenta = "Debe ingresar un numero de cuenta";
      }
      if (!values.correoCuenta) {
        errors.correoCuenta =
          "Debe ingresar un correo electronico para el titular de la cuenta";
      }
    }
    // Fin validate step 5

    // Validate Step 6
    else if (currentStep === 5) {
      if (!values.IdProblema) {
        errors.IdProblema = "Identificación del Problema Requerido";
      } else if (values.IdProblema.length < 5) {
        errors.IdProblema = "Identificación del Problema Es muy corto";
      }
      if (!values.Beneficiarios) {
        errors.Beneficiarios = "Beneficiarios Requerido";
      } else if (values.Beneficiarios.length < 5) {
        errors.Beneficiarios = "Beneficiarios Es muy corto";
      }
      if (!values.DesProyecto) {
        errors.DesProyecto = "Descripcion de problema Requerido";
      } else if (values.DesProyecto.length < 5) {
        errors.DesProyecto = "Descripcion de problema Es muy corto";
      }
      if (!values.ObjetivoGeneral) {
        errors.ObjetivoGeneral = "Objetivo general Requerido";
      } else if (values.ObjetivoGeneral.length < 5) {
        errors.ObjetivoGeneral = "Descripcion de problema Es muy corto";
      }
      if (!values.ObjetivoEspec1) {
        errors.ObjetivoEspec1 = "Objetivo especifico 1 Requerido";
      } else if (values.ObjetivoEspec1.length < 5) {
        errors.ObjetivoEspec1 = "Objetivo especifico 1 Es muy corto";
      }
      if (!values.ObjetivoEspec2) {
        errors.ObjetivoEspec2 = "Objetivo especifico 2 Requerido";
      } else if (values.ObjetivoEspec2.length < 5) {
        errors.ObjetivoEspec2 = "Objetivo especifico 2 Es muy corto";
      }
    }
    // Fin validate step 6

    // Validate Step 7
    else if (currentStep === 6) {
      for (let i = 0; i < 3; i++) {
        if (!values[`ActividadesNombre_${i}`]) {
          errors[`ActividadesNombre_2`] = `Nombre de la actividad Requerido`;
        } else if (values[`ActividadesNombre_${i}`].length < 5) {
          errors[`ActividadesNombre_2`] = `Nombre de la actividad Es muy corto`;
        }

        if (!values[`ActividadesDescripcion_${i}`]) {
          errors[
            `ActividadesDescripcion_2`
          ] = `Descripción de la actividad Requerido`;
        } else if (values[`ActividadesDescripcion_${i}`].length < 5) {
          errors[
            `ActividadesDescripcion_2`
          ] = `Descripción de la actividad Es muy corto`;
        }
      }
      if (!values.PlanDifusion) {
        errors.PlanDifusion = "Plan de difusion Requerido";
      } else if (values.PlanDifusion.length < 5) {
        errors.PlanDifusion = "Plan de difusion Es muy corto";
      }
    }
    // Fin validate step 7

    // Validate Step 8
    else if (currentStep === 7) {
      for (let index = 0; index < 3; index++) {
        if (!values[`GoperacionalesItem_${index}`]) {
          errors[
            `GoperacionalesItem_${index}`
          ] = `Item gasto operacional Requerido`;
        } else if (values[`GoperacionalesItem_${index}`].length < 5) {
          errors[
            `GoperacionalesItem_${index}`
          ] = `Item gasto operacional Es muy corto`;
        }

        if (!values[`GoperacionalesUtilizacion_${index}`]) {
          errors[
            `GoperacionalesUtilizacion_${index}`
          ] = `Utilizacion gasto operacional Requerido`;
        } else if (values[`GoperacionalesUtilizacion_${index}`].length < 5) {
          errors[
            `GoperacionalesUtilizacion_${index}`
          ] = `Utilizacion gasto operacional Es muy corto`;
        }

        const montoSolicitado =
          values[`GoperacionalesMontoSolicitado_${index}`];
        const monto2 = values[`GoperacionalesMontoSolicitado_${index}`];

        if (
          montoSolicitado <= 0 ||
          montoSolicitado == null ||
          montoSolicitado === ""
        ) {
          errors[
            `GoperacionalesMontoSolicitado_${index}`
          ] = `Monto solicitado requerido`;
        }
      }

      var pTotal = 0;
      var gTotal = 0;
      var hTotal = 0;
      var iTotal = 0;

      for (let index = 0; index < 10; index++) {
        const m = values[`GoperacionalesMontoSolicitado_${index}`];
        if (parseInt(m)) {
          pTotal += parseInt(m);
          gTotal += parseInt(m);
        }

        const m2 = values[`InfraestructuraMontoSolicitado_${index}`];
        if (parseInt(m2)) {
          pTotal += parseInt(m2);
          iTotal += parseInt(m2);
        }

        const m3 = values[`RecursosHumanosMontoSolicitado_${index}`];
        if (parseInt(m3)) {
          pTotal += parseInt(m3);
          hTotal += parseInt(m3);
        }
      }
      if (pTotal !== parseInt(values.AporteSolicitado)) {
        errors["totalP"] = "Cantidad invalida" + values.AporteSolicitado;
        setPresupuestoValido(false);
        setMensajePresupuesto(
          "El aporte solicitado es de $" +
            values.AporteSolicitado.toLocaleString("es-CL")
        );
      } else {
        setPresupuestoValido(true);
      }

      setPresupuestoTotal(pTotal);
      setGoperacionalesTotal(gTotal);
      setRecursosHumanosTotal(hTotal);
      setInfraestructuraTotal(iTotal);
    }
    // Fin validate step 8

    // Validate Step 9
    else if (currentStep === 8) {
      console.log("Validate docs:", documentosSolicitud);
      for (var c of getCategoriasDocumentos()) {
        const docsCat = documentosSolicitud.filter((i) => i.categoria === c.id);
        if (docsCat.length < 1) {
          errors["cantidad_documentos_" + c.id] =
            "Se requiere subir al menos un documento en " + c.nombre;
        }
      }
    }
    // Fin validate step 9

    const errorMessages = Object.values(errors);
    setErrores(errorMessages);

    setStepValid((prev) => {
      const newValidations = [...prev];
      newValidations[currentStep] = errorMessages.length === 0;
      return newValidations;
    });
    console.log("Errores de validación: ", errors);
    return errors;
  };

  const errorMessageStyle = {
    color: "red",
  };

  const [goperacionalesTotal, setGoperacionalesTotal] = useState(0);

  const [infraestructuraTotal, setInfraestructuraTotal] = useState(0);

  const handleClick = (step) => {
    if (!animating) {
      if (step === 8 && !isDraft) {
        return;
      }
      setCurrentStep(step);
    }
  };

  const areAllFieldsEmpty = (values) => {
    return (
      !values.NombreProyecto.trim() &&
      !values.NumBeneficiarios &&
      !values.radio &&
      !values.AporteSolicitado
    );
  };

  const handleInput = (e) => {
    const regex = /^[0-9]{1,8}[kK]$/;
    if (!regex.test(e.target.value)) {
      // Mostrar error o cambiar estado para indicar que hay un problema
    }
  };

  if (isLoading) {
    return <CustomLoading />;
  }

  return (
    <Formik
      initialValues={{
        NombreProyecto: isDraft ? solicitudDraft.nombre_proyecto : "",
        NumBeneficiarios: isDraft ? solicitudDraft.numero_beneficiarios : null,
        radio: isDraft ? solicitudDraft.linea_financiamiento : "",
        AporteSolicitado: isDraft ? solicitudDraft.aporte_solicitado : null,

        NombreOrg: isDraft ? solicitudDraft.nombre_organizacion : "",
        RUTOrg: isDraft ? solicitudDraft.rut_organizacion : "",
        DirOrg: isDraft ? solicitudDraft.direccion_org : "",
        NombreRepLegal: isDraft
          ? solicitudDraft.nombre_representante_legal
          : "",
        RUTRepLegal: isDraft ? solicitudDraft.rut_representante_legal : "",
        DirRepLegal: isDraft ? solicitudDraft.direccion_rep_legal : "",
        TelRepLegal: isDraft ? solicitudDraft.telefono_rep_legal : "",
        CorreoRepLegal: isDraft ? solicitudDraft.correo_rep_legal : "",
        NombreRespProyecto: isDraft
          ? solicitudDraft.nombre_responsable_proy
          : "",
        RUTRespProyecto: isDraft ? solicitudDraft.rut_responsable_proy : "",
        DirRespProyecto: isDraft
          ? solicitudDraft.direccion_responsable_proy
          : "",
        TelRespProyecto: isDraft
          ? solicitudDraft.telefono_responsable_proy
          : "",
        CorreoRespProyecto: isDraft
          ? solicitudDraft.correo_responsable_proy
          : "",

        tipoOrganizacion: isDraft ? solicitudDraft.id_tipo_organizacion : null,
        sector: isDraft ? solicitudDraft.sector_id : null,
        idBanco: isDraft ? solicitudDraft.cuenta_id_banco : null,
        tipoCuenta: isDraft ? solicitudDraft.cuenta_tipo : "",
        numeroCuenta: isDraft ? solicitudDraft.cuenta_numero : null,
        titularCuenta: isDraft ? solicitudDraft.cuenta_titular : "",
        correoCuenta: isDraft ? solicitudDraft.cuenta_correo : "",

        IdProblema: isDraft ? respuestas.identificacion_problema : "",
        Beneficiarios: isDraft ? respuestas.beneficiarios : "",
        DesProyecto: isDraft ? respuestas.descripcion_proyecto : "",
        ObjetivoGeneral: isDraft ? respuestas.objetivo_general : "",
        ObjetivoEspec1: isDraft ? respuestas.objetivo_especifico_1 : "",
        ObjetivoEspec2: isDraft ? respuestas.objetivo_especifico_2 : "",
        ObjetivoEspec3: isDraft ? respuestas.objetivo_especifico_3 : "",

        ActividadesNombre_0: isDraft ? respuestas.nombre_actividad_0 : "",
        ActividadesDescripcion_0: isDraft
          ? respuestas.descripcion_actividad_0
          : "",
        ActividadesNombre_1: isDraft ? respuestas.nombre_actividad_1 : "",
        ActividadesDescripcion_1: isDraft
          ? respuestas.descripcion_actividad_1
          : "",
        ActividadesNombre_2: isDraft ? respuestas.nombre_actividad_2 : "",
        ActividadesDescripcion_2: isDraft
          ? respuestas.descripcion_actividad_2
          : "",
        ActividadesNombre_3: isDraft ? respuestas.nombre_actividad_3 : "",
        ActividadesDescripcion_3: isDraft
          ? respuestas.descripcion_actividad_3
          : "",
        ActividadesNombre_4: isDraft ? respuestas.nombre_actividad_4 : "",
        ActividadesDescripcion_4: isDraft
          ? respuestas.descripcion_actividad_4
          : "",
        PlanDifusion: isDraft ? solicitudDraft.plan_difusion : "",

        GoperacionalesItem_0: isDraft
          ? solicitudDraft.gasto_operacional_item_0
          : "",
        GoperacionalesUtilizacion_0: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_0
          : "",
        GoperacionalesMontoSolicitado_0: isDraft
          ? solicitudDraft.gasto_operacional_monto_0
          : "",
        GoperacionalesItem_1: isDraft
          ? solicitudDraft.gasto_operacional_item_1
          : "",
        GoperacionalesUtilizacion_1: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_1
          : "",
        GoperacionalesMontoSolicitado_1: isDraft
          ? solicitudDraft.gasto_operacional_monto_1
          : "",
        GoperacionalesItem_2: isDraft
          ? solicitudDraft.gasto_operacional_item_2
          : "",
        GoperacionalesUtilizacion_2: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_2
          : "",
        GoperacionalesMontoSolicitado_2: isDraft
          ? solicitudDraft.gasto_operacional_monto_2
          : "",
        GoperacionalesItem_3: isDraft
          ? solicitudDraft.gasto_operacional_item_3
          : "",
        GoperacionalesUtilizacion_3: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_3
          : "",
        GoperacionalesMontoSolicitado_3: isDraft
          ? solicitudDraft.gasto_operacional_monto_3
          : "",
        GoperacionalesItem_4: isDraft
          ? solicitudDraft.gasto_operacional_item_4
          : "",
        GoperacionalesUtilizacion_4: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_4
          : "",
        GoperacionalesMontoSolicitado_4: isDraft
          ? solicitudDraft.gasto_operacional_monto_4
          : "",

        GoperacionalesItem_5: isDraft
          ? solicitudDraft.gasto_operacional_item_5
          : "",
        GoperacionalesUtilizacion_5: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_5
          : "",
        GoperacionalesMontoSolicitado_5: isDraft
          ? solicitudDraft.gasto_operacional_monto_5
          : "",

        GoperacionalesItem_6: isDraft
          ? solicitudDraft.gasto_operacional_item_6
          : "",
        GoperacionalesUtilizacion_6: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_6
          : "",
        GoperacionalesMontoSolicitado_6: isDraft
          ? solicitudDraft.gasto_operacional_monto_6
          : "",

        GoperacionalesItem_7: isDraft
          ? solicitudDraft.gasto_operacional_item_7
          : "",
        GoperacionalesUtilizacion_7: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_7
          : "",
        GoperacionalesMontoSolicitado_7: isDraft
          ? solicitudDraft.gasto_operacional_monto_7
          : "",

        GoperacionalesItem_8: isDraft
          ? solicitudDraft.gasto_operacional_item_8
          : "",
        GoperacionalesUtilizacion_8: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_8
          : "",
        GoperacionalesMontoSolicitado_8: isDraft
          ? solicitudDraft.gasto_operacional_monto_8
          : "",

        GoperacionalesItem_9: isDraft
          ? solicitudDraft.gasto_operacional_item_9
          : "",
        GoperacionalesUtilizacion_9: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_9
          : "",
        GoperacionalesMontoSolicitado_9: isDraft
          ? solicitudDraft.gasto_operacional_monto_9
          : "",

        InfraestructuraItem_0: isDraft ? solicitudDraft.infra_item_0 : "",
        InfraestructuraUtilizacion_0: isDraft
          ? solicitudDraft.infra_utilizacion_0
          : "",
        InfraestructuraMontoSolicitado_0: isDraft
          ? solicitudDraft.infra_monto_0
          : "",

        InfraestructuraItem_1: isDraft ? solicitudDraft.infra_item_1 : "",
        InfraestructuraUtilizacion_1: isDraft
          ? solicitudDraft.infra_utilizacion_1
          : "",
        InfraestructuraMontoSolicitado_1: isDraft
          ? solicitudDraft.infra_monto_1
          : "",

        InfraestructuraItem_2: isDraft ? solicitudDraft.infra_item_2 : "",
        InfraestructuraUtilizacion_2: isDraft
          ? solicitudDraft.infra_utilizacion_2
          : "",
        InfraestructuraMontoSolicitado_2: isDraft
          ? solicitudDraft.infra_monto_2
          : "",

        InfraestructuraItem_3: isDraft ? solicitudDraft.infra_item_3 : "",
        InfraestructuraUtilizacion_3: isDraft
          ? solicitudDraft.infra_utilizacion_3
          : "",
        InfraestructuraMontoSolicitado_3: isDraft
          ? solicitudDraft.infra_monto_3
          : "",

        InfraestructuraItem_4: isDraft ? solicitudDraft.infra_item_4 : "",
        InfraestructuraUtilizacion_4: isDraft
          ? solicitudDraft.infra_utilizacion_4
          : "",
        InfraestructuraMontoSolicitado_4: isDraft
          ? solicitudDraft.infra_monto_4
          : "",

        RecursosHumanosItem_0: isDraft ? solicitudDraft.rrhh_item_0 : "",
        RecursosHumanosUtilizacion_0: isDraft
          ? solicitudDraft.rrhh_utilizacion_0
          : "",
        RecursosHumanosMontoSolicitado_0: isDraft
          ? solicitudDraft.rrhh_monto_0
          : "",

        RecursosHumanosItem_1: isDraft ? solicitudDraft.rrhh_item_1 : "",
        RecursosHumanosUtilizacion_1: isDraft
          ? solicitudDraft.rrhh_utilizacion_1
          : "",
        RecursosHumanosMontoSolicitado_1: isDraft
          ? solicitudDraft.rrhh_monto_1
          : "",

        RecursosHumanosItem_2: isDraft ? solicitudDraft.rrhh_item_2 : "",
        RecursosHumanosUtilizacion_2: isDraft
          ? solicitudDraft.rrhh_utilizacion_2
          : "",
        RecursosHumanosMontoSolicitado_2: isDraft
          ? solicitudDraft.rrhh_monto_2
          : "",

        RecursosHumanosItem_3: isDraft ? solicitudDraft.rrhh_item_3 : "",
        RecursosHumanosUtilizacion_3: isDraft
          ? solicitudDraft.rrhh_utilizacion_3
          : "",
        RecursosHumanosMontoSolicitado_3: isDraft
          ? solicitudDraft.rrhh_monto_3
          : "",

        RecursosHumanosItem_4: isDraft ? solicitudDraft.rrhh_item_4 : "",
        RecursosHumanosUtilizacion_4: isDraft
          ? solicitudDraft.rrhh_utilizacion_4
          : "",
        RecursosHumanosMontoSolicitado_4: isDraft
          ? solicitudDraft.rrhh_monto_4
          : "",
        ObsPresupuesto: isDraft ? solicitudDraft.obs_presupuesto : "",
      }}
      validate={(values) => validate(values, currentStep)}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, values }) => (
        <DivContenedorMax>
          <Navbar name={user.nombre_usuario} />
          <Div>
            <ProgressBar>
              <StepProgress>
                {/* Step 0 */}
                <Step className={`${currentStep >= -1 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= -1).toString()}
                    onClick={() => handleClick(-1)}
                  >
                    <span>0</span>
                  </Bullet>
                </Step>

                {/* Step 1 */}
                <Step className={`${currentStep >= 0 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 0).toString()}
                    onClick={() => handleClick(0)}
                  >
                    <span>1</span>
                  </Bullet>
                  {stepValid[0] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Step 2 */}
                <Step className={`${currentStep >= 1 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 1).toString()}
                    onClick={() => handleClick(1)}
                  >
                    <span>2</span>
                  </Bullet>
                  {stepValid[1] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Step 3 */}
                <Step className={`${currentStep >= 2 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 2).toString()}
                    onClick={() => handleClick(2)}
                  >
                    <span>3</span>
                  </Bullet>
                  {stepValid[2] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Step 4 */}
                <Step className={`${currentStep >= 3 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 3).toString()}
                    onClick={() => handleClick(3)}
                  >
                    <span>4</span>
                  </Bullet>
                  {stepValid[3] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Step 5 */}
                <Step className={`${currentStep >= 4 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 4).toString()}
                    onClick={() => handleClick(4)}
                  >
                    <span>5</span>
                  </Bullet>
                  {stepValid[4] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Step 6 */}
                <Step className={`${currentStep >= 5 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 5).toString()}
                    onClick={() => handleClick(5)}
                  >
                    <span>6</span>
                  </Bullet>
                  {stepValid[5] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Step 7 */}
                <Step className={`${currentStep >= 6 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 6).toString()}
                    onClick={() => handleClick(6)}
                  >
                    <span>7</span>
                  </Bullet>
                  {stepValid[6] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Step 8 */}
                <Step className={`${currentStep >= 7 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 7).toString()}
                    onClick={() => handleClick(7)}
                  >
                    <span>8</span>
                  </Bullet>
                  {stepValid[7] ? <CheckIcon /> : <CloseIcon />}
                </Step>

                {/* Last Step */}
                <Step className={`${currentStep >= 8 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 8).toString()}
                    onClick={() => handleClick(8)}
                  >
                    <span>9</span>
                  </Bullet>
                  {stepValid[8] ? <CheckIcon /> : <CloseIcon />}
                </Step>
              </StepProgress>

              {!isDraft || (isDraft && solicitudDraft.estado === "Borrador") ? (
                <div style={{ display: "none" }}>
                  <SaveIcon
                    disabled={draftLoading || areAllFieldsEmpty(values)}
                    onClick={() => {
                      handleSaveDraft(values);
                    }}
                  >
                    <Icon />
                    {draftLoading ? "Cargando..." : "Guardar"}
                  </SaveIcon>
                </div>
              ) : (
                <></>
              )}

              <FechaTerminoIcon>
                {fecha !== null && fecha !== undefined ? (
                  fecha < 0 ? (
                    <p>Fecha de postulación finalizada</p>
                  ) : (
                    <p>Quedan: {fecha} días</p>
                  )
                ) : (
                  <p>Cargando fecha...</p>
                )}
              </FechaTerminoIcon>
            </ProgressBar>

            <DivForm>
              <p>
                <strong>Los campos con * son obligatorios</strong>
              </p>

              {/* Step 0 Resumen */}
              {currentStep === -1 && (
                <DivFlex className={animating ? "fade" : ""}>
                  <div>
                    <br></br>
                    <h2>Instrucciones</h2>
                    <PI>
                      Bienvenido al portal del programa Asignación de recursos
                      para el Desarrollo Social ColbúnCoronel {anio}, iniciativa
                      que Colbún pone a disposición de las organizaciones
                      sociales de la comuna. En esta plataforma podrá ir
                      completando los campos necesarios para ingresar su
                      proyecto. La información puede completarse gradualmente
                      siempre que la respalde haciendo click en el botón
                      Guardar.
                    </PI>{" "}
                    <PI>
                      En cualquier instante podrá verificar las preguntas que
                      faltan responder haciendo click en "Verificación y envío".
                      Sólo cuando toda la información esté completamente
                      ingresada, la postulación podrá ser enviada de forma
                      definitiva. Ante cualquier duda puede escribirnos al
                      correo: contacto@fdscolbun.org
                    </PI>
                    <br></br>
                    {/* <ButtonDownload onClick={() => downloadPDF()}>Descargar pdf</ButtonDownload> */}
                  </div>
                </DivFlex>
              )}
              <Form>
                {currentStep === 0 && (
                  <DivFlex className={animating ? "fade" : ""}>
                    <div>
                      <h2>Resumen</h2>

                      <TextInput
                        name="NombreProyecto"
                        label="Nombre Proyecto"
                        maxLength={500}
                        required={true}
                      />

                      <br />

                      <NumberInput
                        name="NumBeneficiarios"
                        maximo={1000}
                        label="Número de beneficiarios directos del proyecto"
                        required={true}
                        showPrefix={false}
                      />
                      <br />
                      <Label>
                        ¿Cuál es la línea de financiamiento a la que postula con
                        este proyecto?:<Asterisk>*</Asterisk>
                      </Label>
                      {lineasFinanciamiento.map((linea) => (
                        <RadioInput
                          key={linea.id}
                          name="radio"
                          value={linea.nombre}
                          label={linea.nombre}
                          onChange={(e) =>
                            handleLineaFinanciamientoChange(linea.nombre)
                          }
                        />
                      ))}
                      <ErrorMessage
                        name="radio"
                        component="div"
                        style={errorMessageStyle}
                      />
                      <br />
                      <NumberInput
                        name="AporteSolicitado"
                        label={`Aporte Solicitado(max $${maximoFinanciamiento})`}
                        tooltipContent="Ingrese el monto en pesos chilenos"
                        required={true}
                        maximo={maximoFinanciamiento}
                        showPrefix={true}
                        format={true}
                      />
                      <br />
                    </div>
                  </DivFlex>
                )}
                {/* Fin step 0 */}

                {/* Step 1 organizacion */}
                {currentStep === 1 && (
                  <DivFlex className={animating ? "fade" : ""}>
                    <div style={{ width: "100%" }}>
                      <h2>Organización Postulante</h2>
                      <DivFlex>
                        <div style={{ flex: "1" }}>
                          <TextInput
                            name="NombreOrg"
                            label="Nombre de la Organización"
                            tooltipContent="Organización postulante y ejecutora del proyecto"
                            maxLength={32}
                            required={true}
                          />
                          <br />
                          <TextInput
                            name="RUTOrg"
                            label="R.U.T de la organización"
                            tooltipContent="Ingrese el R.U.T de la organización postulante"
                            required={true}
                          />
                          <br />
                          <TextInput
                            name="DirOrg"
                            label="Dirección de la organización"
                            tooltipContent="Ingrese la dirección de la organización postulante indicando Calle, Número de casa, Villa o Población y Comuna"
                            required={true}
                          />
                          <br />
                          <SelectInput
                            name="tipoOrganizacion"
                            label="Tipo de Organización"
                            tooltipContent="Seleccione el tipo de organización"
                            required={true}
                            fetchOptions={fetchTiposOrganizaciones}
                          />
                          <br />
                          <SelectInput
                            name="sector"
                            label="Sector"
                            tooltipContent="Seleccione el sector"
                            required={true}
                            fetchOptions={fetchSectores}
                          />
                          <a onClick={() => setShowImage(true)}>
                            <strong>+</strong> Ver mapa
                          </a>
                          <ImgReferencia
                            onClick={() => setShowImage(false)}
                            visible={showImage}
                            src="/IMG/referencia.jpg"
                          ></ImgReferencia>
                        </div>
                      </DivFlex>
                    </div>
                  </DivFlex>
                )}
                {/* Fin step 1 */}

                {currentStep === 2 && (
                  <DivFlex2 className={animating ? "fade" : ""}>
                    <FormContainer>
                      <h2>Representante legal</h2>
                      <FormGroup style={{ display: "flex", gap: "20px" }}>
                        <div style={{ flex: 1 }}>
                          <TextInput
                            name="NombreRepLegal"
                            label="Nombre del/la representante legal"
                            tooltipContent="Ingrese el nombre del/la representante legal de la organización social"
                            required={true}
                          />

                          <br />

                          <TextInput
                            name="RUTRepLegal"
                            label="R.U.T del/la representante legal"
                            tooltipContent="Ingrese el R.U.T del/la representante legal de la organización social"
                            required={true}
                          />
                          <br />
                          <TextInput
                            name="DirRepLegal"
                            label="Dirección del/la representante legal"
                            tooltipContent="Ingrese la dirección del/la representante legal de la organización social, indicando Calle, Número, Villa o Población y Comuna"
                            required={true}
                          />
                          <br />
                          <NumberInput
                            name="TelRepLegal"
                            label="Teléfono del/la representante legal"
                            tooltipContent="Ingrese el teléfono de contacto del/la representante legal de la organización social"
                            required={true}
                            format={false}
                            maxLength={9}
                          />
                          <br />
                          <TextInput
                            name="CorreoRepLegal"
                            label="Correo electrónico del/la representante legal"
                            tooltipContent="Ingrese el correo electrónico del/la representante legal de la organización social."
                            required={true}
                          />
                          <br />
                        </div>
                      </FormGroup>
                    </FormContainer>
                  </DivFlex2>
                )}
                {/* Fin step 2 */}

                {/* Step 3 */}

                {currentStep === 3 && (
                  <div>
                    <DivFlex2 className={animating ? "fade" : ""}>
                      <FormContainer>
                        <h2>Responsable del proyecto</h2>
                        <FormGroup>
                          <div style={{ flex: 1 }}>
                            <TextInput
                              name="NombreRespProyecto"
                              label="Nombre del/la Responsable del Proyecto"
                              tooltipContent="Ingrese el nombre del/la responsable del proyecto'"
                              required={true}
                            />
                            <br />

                            <TextInput
                              name="RUTRespProyecto"
                              label="R.U.T del/la responsable del proyecto"
                              tooltipContent="Ingrese el R.U.T del/la responsable del proyecto."
                              required={true}
                            />
                            <br />
                            <TextInput
                              name="DirRespProyecto"
                              label="Dirección del/la responsable del proyecto"
                              tooltipContent="Ingrese la dirección del/la responsable del proyecto, indicando Calle, Número, Villa o Población y Comuna. "
                              required={true}
                            />
                            <br />
                            <NumberInput
                              name="TelRespProyecto"
                              label="Teléfono del/la responsable del proyecto"
                              tooltipContent="Ingrese el teléfono del/la responsable del proyecto. "
                              required={true}
                              format={false}
                              maxLength={9}
                            />
                            <br />
                            <TextInput
                              name="CorreoRespProyecto"
                              label="Correo electrónico del/la representante del proyecto"
                              tooltipContent="Ingrese el correo electrónico del/la responsable del proyecto. "
                              required={true}
                            />
                            <br />
                          </div>
                        </FormGroup>
                      </FormContainer>
                    </DivFlex2>
                  </div>
                )}

                {/* Fin step 4 */}

                {/* Step 5 */}
                {currentStep === 4 && (
                  <div>
                    <DivFlex2 className={animating ? "fade" : ""}>
                      <FormContainer>
                        <h2>Datos Bancarios</h2>
                        <FormGroup style={{ display: "flex", gap: "20px" }}>
                          <div style={{ flex: 1 }}>
                            <SelectInput
                              name="idBanco"
                              label="Banco"
                              tooltipContent="Seleccione el banco"
                              required={true}
                              fetchOptions={fetchBancos}
                            />

                            <br />
                            <SelectInput
                              name="tipoCuenta"
                              label="Tipo de cuenta"
                              tooltipContent="Seleccione un tipo de cuenta"
                              required={true}
                              fetchOptions={getTiposDeCuenta}
                            />
                            <br />
                            <TextInput
                              name="numeroCuenta"
                              label="Numero de cuenta"
                              tooltipContent="Numero de cuenta bancaria"
                              required={true}
                            />
                            <br />
                            <TextInput
                              name="titularCuenta"
                              label="Titular de la cuenta"
                              required={true}
                            />
                            <br />
                            <TextInput
                              name="correoCuenta"
                              label="Correo electronico del titular"
                              type="email"
                              required={true}
                            />
                            <p>
                              Los datos proporcionados deben ser de una cuenta
                              de la organización, no se admiten cuentas
                              personales.
                            </p>
                          </div>
                        </FormGroup>
                      </FormContainer>
                    </DivFlex2>
                  </div>
                )}

                {/* Step 5 */}
                {currentStep === 5 && (
                  <div>
                    <DivFlex2 className={animating ? "fade" : ""}>
                      <FormContainer>
                        <h2>Problema</h2>
                        <FormGroup style={{ display: "flex", gap: "20px" }}>
                          <div style={{ flex: 1 }}>
                            <TextArea
                              name="IdProblema"
                              label="Identificación del problema"
                              maxLength={700}
                              rows="13"
                              tooltipContent="Describa la situación que motiva la realización del proyecto y que justifica  <br/>  su búsqueda   de financiamiento. ¿Cuál es el  problema identificado? ¿Qué <br/> datos ayudan a entender las causas del  problema?  ¿Qué efectos tendrá <br/> el problema si no se realiza el proyecto?"
                              required={true}
                            />
                          </div>
                          <div style={{ flex: 1 }}>
                            <TextArea
                              name="Beneficiarios"
                              label="Beneficiarios y beneficiarias"
                              required={true}
                              maxLength={500}
                              tooltipContent="Describa a quienes afecta el problema y quienes recibirán de forma <br/> directa e indirecta el bien o servicio propuesto en este proyecto.<br/>  (Relate cuántos/as son, sus edades, género, condiciones de vida, etc.)"
                            />
                          </div>
                        </FormGroup>
                      </FormContainer>
                    </DivFlex2>

                    <DivFlex2 className={animating ? "fade" : ""}>
                      <FormContainer>
                        <h2>Solución</h2>
                        <FormGroup>
                          <TextArea
                            name="DesProyecto"
                            maxLength={700}
                            label="Descripción general del proyecto"
                            tooltipContent="Describa de qué se trata su proyecto. ¿Qué se pretende realizar? <br/>¿Qué aspectos del problema abordarán y cómo lo abordarán?"
                            required={true}
                          />
                        </FormGroup>
                        <FormGroup style={{ display: "flex", gap: "20px" }}>
                          <div style={{ flex: 1 }}>
                            <TextArea
                              name="ObjetivoGeneral"
                              label="Objetivo General"
                              maxLength={500}
                              tooltipContent="¿Para qué se realizará este proyecto? ¿Qué logros se espera alcanzar?<br/> (Es requisito ingresar un obj. general y tres obj. específicos.)"
                              required={true}
                            />
                          </div>
                          <div style={{ flex: 1 }}>
                            <TextArea
                              maxLength={500}
                              name="ObjetivoEspec1"
                              label="Objetivo Específico 1"
                              required={true}
                            />
                          </div>
                        </FormGroup>
                        <FormGroup style={{ display: "flex", gap: "20px" }}>
                          <div style={{ flex: 1 }}>
                            <TextArea
                              maxLength={500}
                              name="ObjetivoEspec2"
                              label="Objetivo Específico 2"
                              required={true}
                            />
                          </div>
                          <div style={{ flex: 1 }}>
                            <TextArea
                              maxLength={500}
                              name="ObjetivoEspec3"
                              label="Objetivo Específico 3"
                              required={true}
                            />
                          </div>
                        </FormGroup>
                      </FormContainer>
                    </DivFlex2>
                  </div>
                )}
                {/* Fin step 2 */}
                {/* Step 3 Planificacion */}
                {currentStep === 6 && (
                  <DivFlexP4 className={animating ? "fade" : ""}>
                    <FormContainerP4>
                      <h2>Planificación</h2>
                      <FormLabelP4>
                        Actividades del Proyecto:<Asterisk>*</Asterisk>
                      </FormLabelP4>
                      <p>
                        ¿Qué actividades específicas se realizarán durante la
                        ejecución del proyecto? (Puede agregar las filas que
                        necesite para ingresar sus actividades). Debe mencionar
                        por lo menos 3 actividades con sus respectivas
                        descripciones
                      </p>

                      <TableP4>
                        <thead>
                          <tr>
                            <th>Nombre de la Actividad</th>
                            <th>Descripción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.from({ length: 5 }).map((_, index) => (
                            <tr key={index}>
                              <td>
                                <TextArea
                                  maxLength={150}
                                  name={`ActividadesNombre_${index}`}
                                  placeholder="Nombre de la actividad"
                                />
                              </td>
                              <td>
                                <TextArea
                                  maxLength={500}
                                  name={`ActividadesDescripcion_${index}`}
                                  placeholder="Descripción"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </TableP4>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <>
                          <ErrorMessageP4
                            name={`ActividadesNombre_${index}`}
                            component="div"
                          />
                          <ErrorMessageP4
                            name={`ActividadesDescripcion_${index}`}
                            component="div"
                          />
                        </>
                      ))}
                      <FormGroupP4>
                        <FormLabel>
                          Plan de difusión<Asterisk>*</Asterisk>
                        </FormLabel>
                        <p>
                          Responda: ¿Cómo convocará a los beneficiarios y
                          beneficiarias del proyecto? ¿Cómo dará a conocer su
                          proyecto a la comunidad de Coronel? Señale si
                          realizará hitos de lanzamiento o cierre, difusión en
                          medios de comunicación, prensa o redes sociales, etc.
                        </p>
                        <TextArea maxLength={1000} name="PlanDifusion" />
                      </FormGroupP4>
                    </FormContainerP4>
                  </DivFlexP4>
                )}
                {/* Fin step 3 */}

                {/* Step 4 Presupuesto */}
                {currentStep === 7 && (
                  <DivFlexP5 className={animating ? "fade" : ""}>
                    <FormContainerP5>
                      <h2>Presupuesto solicitado</h2>

                      <FormLabelP5>
                        Gastos Operacionales:<Asterisk>*</Asterisk>
                        <p>(Mínimo de gastos operacionales : 3)</p>
                      </FormLabelP5>
                      <p>
                        Corresponde a los gastos asociados a la ejecución del
                        proyecto tales como: materiales de apoyo y/o de oficina
                        para el desarrollo de capacitación y/o entrenamiento;
                        arriendo de espacio físico y de vehículos; gastos de
                        transporte (bencina, peajes y pasajes) del equipo
                        ejecutor y de los participantes. Materiales o servicios
                        para actividades de difusión del proyecto (por ejemplo:
                        pendón, coctel, amplificación, impresiones, afiches,
                        videos, etc.); además de subsidios para el cuidado,
                        transporte y/o alimentación de los participantes que
                        deben ser fundamentados en el proyecto.
                      </p>
                      <p>
                        <strong>
                          Recuerde que la suma de los items no puede superar el
                          monto total solicitado en el proyecto
                        </strong>
                      </p>
                      <TableP5>
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>Utilización</th>
                            <th>Monto solicitado</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.from({ length: 10 }).map((_, index) => (
                            <tr
                              key={index}
                              style={{
                                display: index < goRows ? "table-row" : "none",
                              }}
                            >
                              <td>
                                <TextArea
                                  size="small"
                                  maxLength={255}
                                  name={`GoperacionalesItem_${index}`}
                                  placeholder="Item"
                                />
                              </td>
                              <td>
                                <TextArea
                                  size="small"
                                  maxLength={500}
                                  name={`GoperacionalesUtilizacion_${index}`}
                                  placeholder="Utilización"
                                />
                              </td>
                              <td>
                                <FieldP5
                                  name={`GoperacionalesMontoSolicitado_${index}`}
                                  placeholder="Monto solicitado"
                                  type="number"
                                  showPrefix={true}
                                />
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td>
                              <button
                                type="button"
                                disabled={goRows > 9}
                                onClick={() => setGoRows(goRows + 1)}
                              >
                                Agregar fila
                              </button>
                            </td>
                            <td></td>
                            <td>
                              <FieldP5
                                name="GoperacionalesExtraTotal"
                                showPrefix={true}
                                placeholder="TOTAL"
                                value={goperacionalesTotal}
                                readOnly
                              />
                            </td>
                          </tr>
                        </tbody>
                      </TableP5>
                      {Array.from({ length: 10 }).map((_, index) => (
                        <>
                          <ErrorMessageP5
                            name={`GoperacionalesItem_${index}`}
                            component="div"
                          />
                          <ErrorMessageP5
                            name={`GoperacionalesUtilizacion_${index}`}
                            component="div"
                          />
                          <ErrorMessageP5
                            name={`GoperacionalesMontoSolicitado_${index}`}
                            component="div"
                          />
                        </>
                      ))}

                      <FormLabelP5>
                        Infraestructura:<Asterisk>*</Asterisk>
                      </FormLabelP5>
                      <p>
                        Considera todos los gastos involucrados en la reparación
                        o construcción de infraestructura. Involucra materiales
                        y mano de obra.
                      </p>
                      <TableP5>
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>Utilización</th>
                            <th>Monto solicitado</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.from({ length: 5 }).map((value, index) => (
                            <tr
                              key={index}
                              style={{
                                display: index < inRows ? "table-row" : "none",
                              }}
                            >
                              <td>
                                <TextArea
                                  size="small"
                                  maxLength={255}
                                  name={`InfraestructuraItem_${index}`}
                                  placeholder="Item"
                                />
                              </td>
                              <td>
                                <TextArea
                                  size="small"
                                  maxLength={500}
                                  name={`InfraestructuraUtilizacion_${index}`}
                                  placeholder="Utilización"
                                />
                              </td>
                              <td>
                                <FieldP5
                                  name={`InfraestructuraMontoSolicitado_${index}`}
                                  placeholder="Monto solicitado"
                                  type="number"
                                  showPrefix={true}
                                />
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td>
                              <button
                                type="button"
                                disabled={inRows > 4}
                                onClick={() => setInRows(inRows + 1)}
                              >
                                Agregar fila
                              </button>
                            </td>
                            <td></td>
                            <td>
                              <FieldP5
                                name="InfraestructuraExtraTotal"
                                showPrefix={true}
                                placeholder="TOTAL"
                                value={infraestructuraTotal}
                                readOnly
                              />
                            </td>
                          </tr>
                        </tbody>
                      </TableP5>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <>
                          <ErrorMessageP5
                            name={`InfraestructuraItem_${index}`}
                            component="div"
                          />
                          <ErrorMessageP5
                            name={`InfraestructuraUtilizacion_${index}`}
                            component="div"
                          />
                          <ErrorMessageP5
                            name={`InfraestructuraMontoSolicitado_${index}`}
                            component="div"
                          />
                        </>
                      ))}

                      <FormLabelP5>
                        Recursos Humanos:<Asterisk>*</Asterisk>
                      </FormLabelP5>
                      <p>
                        Corresponde a los pagos de honorarios a profesionales,
                        técnicos, monitores o talleristas como complemento al
                        equipo existente en la propia institución postulante
                        para el desarrollo de las actividades, y cuyos servicios
                        se encuentren debidamente justificados en el proyecto.
                      </p>
                      <TableP5>
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>Utilización</th>
                            <th>Monto solicitado</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.from({ length: 5 }).map((value, index) => (
                            <tr
                              key={index}
                              style={{
                                display: index < rhRows ? "table-row" : "none",
                              }}
                            >
                              <td>
                                <TextArea
                                  size="small"
                                  maxLength={255}
                                  name={`RecursosHumanosItem_${index}`}
                                  placeholder="Item"
                                />
                              </td>
                              <td>
                                <TextArea
                                  size="small"
                                  maxLength={500}
                                  name={`RecursosHumanosUtilizacion_${index}`}
                                  placeholder="Utilización"
                                />
                              </td>
                              <td>
                                <FieldP5
                                  name={`RecursosHumanosMontoSolicitado_${index}`}
                                  placeholder="Monto solicitado"
                                  type="number"
                                  showPrefix={true}
                                />
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td>
                              <button
                                type="button"
                                disabled={rhRows > 4}
                                onClick={() => setRhRows(rhRows + 1)}
                              >
                                Agregar fila
                              </button>
                            </td>
                            <td></td>
                            <td>
                              <FieldP5
                                name="RecursosHumanosExtraTotal"
                                showPrefix={true}
                                placeholder="TOTAL"
                                value={recursosHumanosTotal}
                                readOnly
                              />
                            </td>
                          </tr>
                        </tbody>
                      </TableP5>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <>
                          <ErrorMessageP5
                            name={`RecursosHumanosItem_${index}`}
                            component="div"
                          />
                          <ErrorMessageP5
                            name={`RecursosHumanosUtilizacion_${index}`}
                            component="div"
                          />
                          <ErrorMessageP5
                            name={`RecursosHumanosMontoSolicitado_${index}`}
                            component="div"
                          />
                        </>
                      ))}

                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <p
                          style={{
                            width: "300px",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "1.3rem",
                          }}
                        >
                          <strong>Total</strong>: $
                          {presupuestoTotal.toLocaleString("es-CL")}
                          <br></br>
                          {!presupuestoValido && (
                            <span style={{ color: "red", fontSize: "1rem" }}>
                              Presupuesto inválido. {mensajePresupuesto}
                            </span>
                          )}
                        </p>
                      </div>

                      <FormGroupP4>
                        <FormLabel>
                          Presupuesto aportado por la organizacion (si es que
                          aplica)
                        </FormLabel>
                        <p>
                          Puede incorporar el aporte que hacen monetario y el no
                          monetario (pero valorizado).
                        </p>
                        <TextArea maxLength={400} name="ObsPresupuesto" />
                      </FormGroupP4>
                    </FormContainerP5>
                  </DivFlexP5>
                )}
                {/* Fin step 4 */}

                {/* Step 5 Adjuntos */}
                {currentStep === 8 && (
                  <DivFlex
                    className={animating ? "fade" : ""}
                    style={{ width: "100%" }}
                  >
                    <div style={{ width: "100%" }}>
                      <h2>Adjuntos </h2>
                      <p>
                        <strong>
                          Tamaño maximo por archivo (3MB) - Se requiere al menos
                          1 archivo por categoria
                        </strong>
                      </p>

                      {getCategoriasDocumentos().map((c) => (
                        <div
                          style={{
                            borderBottom: "1px solid #bbbbbb",
                            paddingBottom: "12px",
                            marginBottom: "4px",
                          }}
                        >
                          <h5>{c.nombre}</h5>

                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "start",
                            }}
                          >
                            {documentosSolicitud
                              .filter((i) => i.categoria === c.id)
                              .map((doc, index) => (
                                <DocumentItem
                                  documento={doc}
                                  onDelete={(d) => handleDelete(d)}
                                ></DocumentItem>
                              ))}
                            <FileButtonUploader
                              disabled={
                                documentosSolicitud.filter(
                                  (i) => i.categoria === c.id
                                ).length > 4
                              }
                              onUploadSuccess={(d) => handleUploadSucces(d)}
                              categoria={c.id}
                            >
                              Subir archivo
                            </FileButtonUploader>
                          </div>
                        </div>
                      ))}
                    </div>
                  </DivFlex>
                )}
                {/* Fin step 5 */}
                <br />
                <br />

                <DivButtons>
                  <div>
                    {currentStep !== -1 && (
                      <ButtonAtras
                        type="button"
                        onClick={() => {
                          prevStep(values);
                        }}
                        disabled={currentStep === -1}
                      >
                        Anterior
                      </ButtonAtras>
                    )}
                  </div>

                  <div>
                    {currentStep === 8 ? (
                      <div>
                        <ButtonEnviar
                          type="submit"
                          disabled={
                            !(
                              stepValid[0] &&
                              stepValid[1] &&
                              stepValid[2] &&
                              stepValid[3] &&
                              stepValid[4] &&
                              stepValid[5] &&
                              stepValid[6] &&
                              stepValid[7]
                            )
                          }
                        >
                          {!isLoadingSubmit ? "Enviar" : "Enviando..."}
                        </ButtonEnviar>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    {currentStep !== 8 && (
                      <ButtonNext
                        type="button"
                        onClick={() => {
                          nextStep(values);
                        }}
                        disabled={currentStep === 8}
                      >
                        Siguiente
                      </ButtonNext>
                    )}
                  </div>
                </DivButtons>
              </Form>
            </DivForm>
            <ToastContainer autoClose={3000} />
            <br />
          </Div>
        </DivContenedorMax>
      )}
    </Formik>
  );
};

export default MultiStepForm;
